export default __webpack_public_path__ + "static/media/question.579902d6.jpg";